// @flow

import {createActions, createReducer} from 'reduxsauce'
import Immutable from 'seamless-immutable'
import * as _ from "lodash";

/* ------------- Types and Action Creators ------------- */

const {Types, Creators} = createActions({
    getUserStatesRequest: ['campaign'],
    getUserStatesSuccess: ['userStates'],
    getUserStatesError: ['error'],

    getSpecificUserRequest: ['user'],
    getSpecificUserSuccess: ['userDetails'],
    getSpecificUserError: ['error'],

    sendSpecificUserInviteRequest: ['user'],
    sendSpecificUserInviteSuccess: ['updatedUser'],
    sendSpecificUserInviteError: ['error'],

    updateSpecificUserRequest: ['user'],
    updateSpecificUserSuccess: ['updatedUser', 'updateCampaign'],
    updateSpecificUserError: ['error'],

    addSpecificUserVehicleRequest: ['vehicle'],
    addSpecificUserVehicleSuccess: ['newVehicle'],
    addSpecificUserVehicleError: ['error'],

    updateSpecificUserVehicleRequest: ['vehicle'],
    updateSpecificUserVehicleSuccess: ['updatedVehicle'],
    updateSpecificUserVehicleError: ['error'],

    updatePendingSpecificUserInfo: ['userId', 'status']
})

export const SpecificUserTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    fetching: true,
    userDetails: undefined,
    userStates: undefined,
    error: undefined,
    isUserUpdate: false,
    isUserCampaignUpdate: false,
    isVehicleUpdating: false,
    isVehicleUpdate: false,
})

/* ------------- Reducers ------------- */

export const userStatesRequest = (state: Object, action) => state.merge({
    fetching: true,
    userStates: undefined,
    error: undefined,
    isUserUpdate: false
})

export const userStatesSuccess = (state: Object, {userStates}: Object) => {
    let userObj = Object.assign({}, userStates)
    return state.merge({
        fetching: false,
        userStates: userObj,
        error: undefined,
        isUserUpdate: true
    })
}

export const userStatesError = (state: Object, {error}: Object) => state.merge({
    fetching: false,
    error,
    userStates: undefined,
    roles: undefined,
    isUserUpdate: false
})

export const specificUserRequest = (state: Object, action) => state.merge({
    fetching: true,
    userDetails: undefined,
    error: undefined,
    isUserUpdate: false
})

export const specificUserSuccess = (state: Object, {userDetails}: Object) => {
    let userObj = Object.assign({}, userDetails)
    return state.merge({
        fetching: false,
        userDetails: userObj,
        error: undefined,
        isUserUpdate: true
    })
}

export const specificUserError = (state: Object, {error}: Object) => state.merge({
    fetching: false,
    error,
    userDetails: undefined,
    roles: undefined,
    isUserUpdate: false
})

export const sendSpecificUserInviteRequest = (state: Object) => {
    const {userDetails} = state
    let userObj = Object.assign({}, userDetails)
    return state.merge({
        fetching: true,
        userDetails: userObj,
        error: undefined,
        isUserUpdate: false
    })
}

export const sendSpecificUserInviteSuccess = (state: Object, {updatedUser}: Object) => {
    const {userDetails} = state

    let userObj = Object.assign({}, updatedUser, {
        campaign: userDetails.campaign
    })

    return state.merge({
        fetching: false,
        userDetails: userObj,
        error: undefined,
        isUserUpdate: true
    })
}

export const sendSpecificUserInviteError = (state: Object, {error}: Object) => state.merge({
    fetching: false,
    error,
    isUserUpdate: false
})


export const processUpdateSpecificUserRequest = (state: Object) => {
    const {userDetails} = state
    let userObj = Object.assign({}, userDetails)
    return state.merge({
        fetching: true,
        userDetails: userObj,
        error: undefined,
        isUserUpdate: false,
        isUserCampaignUpdate: false
    })
}

export const processUpdateSpecificUserSuccess = (state: Object, {updatedUser, updateCampaign}: Object) => {
    const {userDetails} = state
    let userObj = userDetails;

    if(userObj.id === updatedUser.id){
      userObj = Object.assign({}, updatedUser)
    }

    return state.merge({
        fetching: false,
        userDetails: userObj,
        error: undefined,
        isUserUpdate: true,
        isUserCampaignUpdate: updateCampaign
    })
}

export const processUpdateSpecificUserError = (state: Object, {error}: Object) => state.merge({
    fetching: false,
    error,
    isUserUpdate: false,
    isUserCampaignUpdate: true
})

// add new vehicle

export const processAddSpecificUserVehicleRequest = (state: Object) => {
    return state.merge({
        isVehicleUpdating: true,
        error: undefined,
        isVehicleUpdate: false
    })
}

export const processAddSpecificUserVehicleSuccess = (state: Object, {newVehicle}: Object) => {
    const {userDetails} = state
    const _userDetails = _.cloneDeep(userDetails);
    const vehicles = _userDetails.vehicles || [];

    // check if same user
    if (newVehicle.user && _userDetails.id === newVehicle.user.id) {
        let find = _.find(vehicles, vehicle => {
            return vehicle.id === newVehicle.id
        });

        if (!find) {
            vehicles.push(newVehicle)
        }
    }

    return state.merge({
        isVehicleUpdating: false,
        userDetails: _userDetails,
        error: undefined,
        isVehicleUpdate: true
    })
}

export const processAddSpecificUserVehicleError = (state: Object, {error}: Object) => state.merge({
    isVehicleUpdating: false,
    isVehicleUpdate: false,
    error,
})


// update vehicle

export const processUpdateSpecificUserVehicleRequest = (state: Object) => {
    return state.merge({
        isVehicleUpdating: true,
        error: undefined,
        isVehicleUpdate: false
    })
}

export const processUpdateSpecificUserVehicleSuccess = (state: Object, {updatedVehicle}: Object) => {
    const {userDetails} = state
    const _userDetails = _.cloneDeep(userDetails);
    const vehicles = _userDetails.vehicles;

    let find = _.find(vehicles, vehicle => {
        return vehicle.id === updatedVehicle.id
    })

    if (find) {
        const index = _.indexOf(vehicles, find)
        vehicles[index] = updatedVehicle;
    }

    return state.merge({
        isVehicleUpdating: false,
        userDetails: _userDetails,
        error: undefined,
        isVehicleUpdate: true
    })
}

export const processUpdateSpecificUserVehicleError = (state: Object, {error}: Object) => state.merge({
    isVehicleUpdating: false,
    error,
    isVehicleUpdate: false
})

export const processUpdatePendingSpecificUserInfo = (state: Object, {userId, status}: Object) => {
    let {userDetails} = state

    if (userDetails.id === userId) {
        userDetails = Immutable.set(userDetails, 'status', status)
    }

    return state.merge({
        fetching: false,
        userDetails,
        error: undefined
    })
}
/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
    [Types.GET_USER_STATES_REQUEST]: userStatesRequest,
    [Types.GET_USER_STATES_SUCCESS]: userStatesSuccess,
    [Types.GET_USER_STATES_ERROR]: userStatesError,

    [Types.GET_SPECIFIC_USER_REQUEST]: specificUserRequest,
    [Types.GET_SPECIFIC_USER_SUCCESS]: specificUserSuccess,
    [Types.GET_SPECIFIC_USER_ERROR]: specificUserError,

    [Types.SEND_SPECIFIC_USER_INVITE_REQUEST]: sendSpecificUserInviteRequest,
    [Types.SEND_SPECIFIC_USER_INVITE_SUCCESS]: sendSpecificUserInviteSuccess,
    [Types.SEND_SPECIFIC_USER_INVITE_ERROR]: sendSpecificUserInviteError,

    [Types.UPDATE_SPECIFIC_USER_REQUEST]: processUpdateSpecificUserRequest,
    [Types.UPDATE_SPECIFIC_USER_SUCCESS]: processUpdateSpecificUserSuccess,
    [Types.UPDATE_SPECIFIC_USER_ERROR]: processUpdateSpecificUserError,

    [Types.ADD_SPECIFIC_USER_VEHICLE_REQUEST]: processAddSpecificUserVehicleRequest,
    [Types.ADD_SPECIFIC_USER_VEHICLE_SUCCESS]: processAddSpecificUserVehicleSuccess,
    [Types.ADD_SPECIFIC_USER_VEHICLE_ERROR]: processAddSpecificUserVehicleError,

    [Types.UPDATE_SPECIFIC_USER_VEHICLE_REQUEST]: processUpdateSpecificUserVehicleRequest,
    [Types.UPDATE_SPECIFIC_USER_VEHICLE_SUCCESS]: processUpdateSpecificUserVehicleSuccess,
    [Types.UPDATE_SPECIFIC_USER_VEHICLE_ERROR]: processUpdateSpecificUserVehicleError,

    [Types.UPDATE_PENDING_SPECIFIC_USER_INFO]: processUpdatePendingSpecificUserInfo
})
